var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDossierMois(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#82368C",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.25 33.032h.917v.903h-.917zM41.25 31.226h.917v.903h-.917zM41.25 29.42h.917v.903h-.917zM23.833 27.161h.917v.904h-.917zM23.833 28.968h.917v4.967h-.917zM27.5 23.548h.917v.904H27.5zM23.833 23.548h.917v.904h-.917zM25.667 23.548h.916v.904h-.916zM26.583 11.806h11v.904h-11zM36.667 13.613h.916v.903h-.916zM26.583 13.613h9.167v.903h-9.167zM30.708 17.226h8.709v.903h-8.709zM38.5 19.032h.917v.903H38.5zM30.708 19.032h6.875v.903h-6.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.708 23.548h-.458V15.42h-1.833V10H24.75v11.742h-.458C23.028 21.742 22 22.755 22 24v11.742C22 36.987 23.028 38 24.292 38h17.416C42.972 38 44 36.987 44 35.742v-9.936c0-1.245-1.028-2.258-2.292-2.258zm-1.375 0h-5.199c-.362 0-.715-.144-.972-.397l-.76-.747a2.296 2.296 0 0 0-1.62-.662h-1.99v-5.42h10.541v7.226zM25.667 10.903H38.5v4.516h-9.625v6.323h-3.208V10.903zm-1.375 11.742h7.49c.362 0 .716.145.972.397l.76.748a2.295 2.295 0 0 0 1.62.662h6.574c.597 0 1.101.379 1.291.903H22.917V24c0-.747.617-1.355 1.375-1.355zm17.416 14.452H24.292a1.367 1.367 0 0 1-1.375-1.355v-9.484h20.166v9.484c0 .747-.617 1.355-1.375 1.355z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.25 34.032h.917v.903h-.917zM43.25 32.226h.917v.903h-.917zM43.25 30.42h.917v.903h-.917zM25.833 28.161h.917v.904h-.917zM25.833 29.968h.917v4.967h-.917zM29.5 24.548h.917v.904H29.5zM25.833 24.548h.917v.904h-.917zM27.667 24.548h.916v.904h-.916zM28.583 12.806h11v.904h-11zM38.667 14.613h.916v.903h-.916zM28.583 14.613h9.167v.903h-9.167zM32.708 18.226h8.709v.903h-8.709zM40.5 20.032h.917v.903H40.5zM32.708 20.032h6.875v.903h-6.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.708 24.548h-.458V16.42h-1.833V11H26.75v11.742h-.458C25.028 22.742 24 23.755 24 25v11.742C24 37.987 25.028 39 26.292 39h17.416C44.972 39 46 37.987 46 36.742v-9.936c0-1.245-1.028-2.258-2.292-2.258zm-1.375 0h-5.199c-.362 0-.715-.144-.972-.397l-.76-.747a2.296 2.296 0 0 0-1.62-.662h-1.99v-5.42h10.541v7.226zM27.667 11.903H40.5v4.516h-9.625v6.323h-3.208V11.903zm-1.375 11.742h7.49c.362 0 .716.145.972.397l.76.748a2.295 2.295 0 0 0 1.62.662h6.574c.597 0 1.101.379 1.291.903H24.917V25c0-.747.617-1.355 1.375-1.355zm17.416 14.452H26.292a1.367 1.367 0 0 1-1.375-1.355v-9.484h20.166v9.484c0 .747-.617 1.355-1.375 1.355z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDossierMois);
export default __webpack_public_path__ + "static/media/ic-dossier-mois.8feb08fc85414c3c9b6ad8d75d88ac59.svg";
export { ForwardRef as ReactComponent };